function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9812 6.14044L18.85 1.61294C18.7113 1.05669 18.2113 0.666687 17.6375 0.666687H2.36375C1.79 0.666687 1.29 1.05669 1.15 1.61294L0.01875 6.14044C0.00625 6.18919 0 6.24044 0 6.29169C0 8.01419 1.33125 9.41669 2.96875 9.41669C3.92 9.41669 4.76875 8.94294 5.3125 8.20794C5.85625 8.94294 6.705 9.41669 7.65625 9.41669C8.6075 9.41669 9.45625 8.94294 10 8.20794C10.5438 8.94294 11.3913 9.41669 12.3438 9.41669C13.2963 9.41669 14.1438 8.94294 14.6875 8.20794C15.2313 8.94294 16.0788 9.41669 17.0312 9.41669C18.6688 9.41669 20 8.01419 20 6.29169C20 6.24044 19.9937 6.18919 19.9812 6.14044Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0312 10.6666C16.18 10.6666 15.3713 10.4066 14.6875 9.93163C13.32 10.8829 11.3675 10.8829 10 9.93163C8.6325 10.8829 6.68 10.8829 5.3125 9.93163C4.62875 10.4066 3.82 10.6666 2.96875 10.6666C2.355 10.6666 1.77625 10.5229 1.25 10.2779V16.9166C1.25 17.6066 1.81 18.1666 2.5 18.1666H6.59091C7.09299 18.1666 7.5 17.7596 7.5 17.2575V14.0757C7.5 13.5736 7.90701 13.1666 8.40909 13.1666H11.5909C12.093 13.1666 12.5 13.5736 12.5 14.0757V17.2575C12.5 17.7596 12.907 18.1666 13.4091 18.1666H17.5C18.19 18.1666 18.75 17.6066 18.75 16.9166V10.2779C18.2238 10.5229 17.645 10.6666 17.0312 10.6666Z",
  fill: "#738BA5"
});

function SvgVendorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorsIcon);
export default __webpack_public_path__ + "static/media/VendorsIcon.f1910a4b.svg";
export { ForwardRef as ReactComponent };